import React, { useState, useEffect } from 'react';
import DownloaderAdmin from './DownloaderAdmin';
import Login from './Login';
export default function MasterPage() {    
    const [UserId, SetUserId] = useState('');  
      
    return (
        <div className="content-wrapper">
            <div className="container" style={{ maxWidth: "99%", backgroundColor: "white", textAlign: "center", display:" flex",justifyContent: "center"}}>
                {UserId !== '' ? <DownloaderAdmin UserId={UserId} /> : <Login UserloginId={(e) => SetUserId(e)} />} 
            </div>
        </div>
    );
}
